import { EntityState } from '@ngrx/entity';
import { Country } from '@shared/models/country';

export const countryFeatureKey = 'country';

export interface CountryState extends EntityState<Country> {
  error: any;
  totalCount: number;
}
